
import { axiosInstance } from ".."

const projectDetail = async (projectid) => {
  return new Promise(async (resolve, reject) => {
    axiosInstance
      .get(`internal/projects/list?projectID=${projectid}`)
      .then((res) => {
        if (res.status === 200) {
          console.log(res);
          return resolve(res);
        }
        return resolve(res);
      })
      .catch((err) => {
        return reject(err);
      });
  });
};

export default projectDetail;